import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';


const AskaLibrarian = () =>{
  
  return (
    <div className="AskaLibrarian">
    
    <section className="inner-banner banner-align">
      <img className="img-fluid" src="./assets/img/innerbanner/contact.jpg" alt=""/>
    </section>
    <section  className="research-box-area">
         <Container>
       
            <div className='information-content'>
              <h2>Ask a Librarian</h2>
              <p>Have a question or suggestion about the library, you may contact our passionate and dedicated team.</p>
            </div>
            <Row className=" py-4">
                <Col lg={4} className="">
                  <div className="research-box">
                    <h5>IT & Help Desk</h5>
                    <p>Extention: <b>4224</b></p>
                    <p>E-mail:  
                      <b>
                        {/* <ButtonMailto label="servicedesk@habib.edu.pk" mailto="mailto:servicedesk@habib.edu.pk" /> */}
                        <Link to='' onClick={() => window.location = 'mailto:servicedesk@habib.edu.pk'}> 
                            servicedesk@habib.edu.pk
                        </Link>
                      </b>
                    </p>
                    
                  </div>
                </Col>
                <Col lg={4} className="border-end border-start">
                  <div className="research-box">
                    <h5>Printing, Scanning and Photocopy</h5>
                    <p>Extention: <b>7109</b></p>
                    <p>E-mail:  
                      <b>
                        {/* <ButtonMailto label="servicedesk@habib.edu.pk" mailto="mailto:servicedesk@habib.edu.pk" /> */}
                        <Link to='' onClick={() => window.location = 'mailto:print.services@habib.edu.pk'}> 
                           print.services@habib.edu.pk
                        </Link>
                      </b>
                    </p>
                  </div>
                </Col>
                <Col lg={4} className="">
                  <div className="research-box">
                    <h5>For General Inquiries and Suggestions</h5>
                    <p>Extention: <b>7105</b></p>
                    <p>E-mail:  
                      <b>
                        {/* <ButtonMailto label="servicedesk@habib.edu.pk" mailto="mailto:servicedesk@habib.edu.pk" /> */}
                        <Link to='' onClick={() => window.location = 'mailto:library@habib.edu.pk'}> 
                           library@habib.edu.pk
                        </Link>
                      </b>
                    </p>
                  </div>
                </Col>
               
            </Row>
         </Container>
    </section>
   
  </div>
  );
}
export default AskaLibrarian;